"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverContent = exports.PopoverTrigger = exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _console = require("@instructure/console");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _keycode = _interopRequireDefault(require("keycode"));
var _ContextView = _interopRequireDefault(require("@instructure/ui-layout/lib/components/ContextView"));
var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));
var _Dialog = _interopRequireDefault(require("@instructure/ui-a11y/lib/components/Dialog"));
var _bidirectional = _interopRequireDefault(require("@instructure/ui-i18n/lib/bidirectional"));
var _CloseButton = _interopRequireDefault(require("@instructure/ui-buttons/lib/components/CloseButton"));
var _Position = _interopRequireWildcard(require("@instructure/ui-layout/lib/components/Position"));
var _uiPropTypes = require("@instructure/ui-prop-types");
var _findDOMNode = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/findDOMNode"));
var _LayoutPropTypes = _interopRequireDefault(require("@instructure/ui-layout/lib/utils/LayoutPropTypes"));
var _ComponentIdentifier3 = _interopRequireWildcard(require("@instructure/ui-utils/lib/react/ComponentIdentifier"));
var _containsActiveElement = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/containsActiveElement"));
var _createChainedFunction = _interopRequireDefault(require("@instructure/ui-utils/lib/createChainedFunction"));
var _requestAnimationFrame = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/requestAnimationFrame"));
var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));
var _shallowEqual = _interopRequireDefault(require("@instructure/ui-utils/lib/shallowEqual"));
var _px = _interopRequireDefault(require("@instructure/ui-utils/lib/px"));
var _handleMouseOverOut = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/handleMouseOverOut"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _deprecated = _interopRequireDefault(require("@instructure/ui-utils/lib/react/deprecated"));
var _uid = _interopRequireDefault(require("@instructure/uid"));
var _calculateElementPosition = require("@instructure/ui-layout/lib/utils/calculateElementPosition");
var _mirrorPlacement = require("@instructure/ui-layout/lib/utils/mirrorPlacement");
var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _dec4, _dec5, _dec6, _class5, _class6, _temp3;
var PopoverTrigger = (_dec = (0, _uiTestable.default)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_ComponentIdentifier) {
  (0, _inherits2.default)(PopoverTrigger, _ComponentIdentifier);
  function PopoverTrigger() {
    (0, _classCallCheck2.default)(this, PopoverTrigger);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PopoverTrigger).apply(this, arguments));
  }
  return PopoverTrigger;
}(_ComponentIdentifier3.default), _class2.displayName = 'PopoverTrigger', _temp)) || _class);
exports.PopoverTrigger = PopoverTrigger;
var PopoverContent = (_dec2 = (0, _uiTestable.default)(), _dec2(_class3 = (_temp2 = _class4 = /*#__PURE__*/
function (_ComponentIdentifier2) {
  (0, _inherits2.default)(PopoverContent, _ComponentIdentifier2);
  function PopoverContent() {
    (0, _classCallCheck2.default)(this, PopoverContent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PopoverContent).apply(this, arguments));
  }
  return PopoverContent;
}(_ComponentIdentifier3.default), _class4.displayName = 'PopoverContent', _temp2)) || _class3);
/**
---
category: components
---
**/

exports.PopoverContent = PopoverContent;
var Popover = (_dec3 = (0, _uiTestable.default)(), _dec4 = (0, _deprecated.default)('3.0.0', {
  renderOffscreen: 'shouldRenderOffscreen',
  rootClose: 'shouldCloseOnDocumentClick'
}), _dec5 = (0, _deprecated.default)('5.0.0', {
  closeButtonLabel: true,
  closeButtonRef: true,
  applicationElement: true
}), _dec6 = (0, _bidirectional.default)(), _dec3(_class5 = _dec4(_class5 = _dec5(_class5 = _dec6(_class5 = (_temp3 = _class6 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Popover, _Component);
  function Popover(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Popover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popover).call(this, props));
    _this.show = function () {
      if (typeof _this.props.show === 'undefined') {
        _this.setState({
          show: true
        });
      }
      if (typeof _this.props.onToggle === 'function') {
        _this.props.onToggle(true);
      }
    };
    _this.hide = function (e, documentClick) {
      var _this$props = _this.props,
        onDismiss = _this$props.onDismiss,
        onToggle = _this$props.onToggle,
        show = _this$props.show;
      if (typeof show === 'undefined') {
        _this.setState(function (_ref) {
          var show = _ref.show;
          if (show) {
            onDismiss(e, documentClick);
          }
          return {
            show: false
          };
        });
      } else if (show) {
        onDismiss(e, documentClick);
      }
      onToggle(false);
    };
    _this.toggle = function () {
      if (_this.shown) {
        _this.hide();
      } else {
        _this.show();
      }
    };
    _this.handleDialogDismiss = function () {
      var _this2;
      if (!_this.props.shouldReturnFocus && _this.props.shouldFocusContentOnTriggerBlur) {
        var trigger = (0, _findDOMNode.default)(_this._trigger);
        if (trigger && typeof trigger.focus === 'function') {
          trigger.focus();
        }
      }
      (_this2 = _this).hide.apply(_this2, arguments);
    };
    _this.handleDialogBlur = function (event) {
      if (event.keyCode === _keycode.default.codes.tab && event.shiftKey && _this.props.shouldFocusContentOnTriggerBlur) {
        return;
      }
      _this.hide(event);
    };
    _this.handleTriggerKeyDown = function (event) {
      if (!_this.props.shouldFocusContentOnTriggerBlur) {
        return;
      }
      if (event.keyCode === _keycode.default.codes.tab && !event.shiftKey) {
        event.preventDefault();
        _this._raf.push((0, _requestAnimationFrame.default)(function () {
          _this._dialog && _this._dialog.focus();
        }));
      }
    };
    _this.handleTriggerBlur = function (event) {
      if (_this.props.on.indexOf('focus') > -1) {
        _this._raf.push((0, _requestAnimationFrame.default)(function () {
          if (!(0, _containsActiveElement.default)(_this._view)) {
            _this.hide();
          }
        }));
      }
    };
    _this.handlePositionChanged = function (_ref2) {
      var placement = _ref2.placement;
      _this.setState((0, _objectSpread2.default)({
        closeButtonPlacement: _this.getCloseButtonPlacement(_this.props),
        placement: placement
      }, _this.computeOffsets(placement)));
    };
    _this.state = {
      placement: props.placement,
      offsetX: props.offsetX,
      offsetY: props.offsetY
    };
    if (typeof props.show === 'undefined') {
      _this.state.show = props.defaultShow;
    }
    _this._id = _this.props.id || (0, _uid.default)('Popover');
    _this._raf = [];
    return _this;
  }
  (0, _createClass2.default)(Popover, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;
      this._handleMouseOver = _handleMouseOverOut.default.bind(null, function () {
        _this3.show();
      });
      this._handleMouseOut = _handleMouseOverOut.default.bind(null, function () {
        _this3.hide();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._raf.forEach(function (request) {
        return request.cancel();
      });
      this._raf = [];
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !((0, _shallowEqual.default)(this.props, nextProps) && (0, _shallowEqual.default)(this.state, nextState));
    }
  }, {
    key: "getCloseButtonPlacement",
    value: function getCloseButtonPlacement(props) {
      var placement = props.placement.split(' ');
      if (placement.indexOf('end') >= 0) {
        return 'start';
      } else {
        return 'end';
      }
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var _this4 = this;
      var trigger = (0, _ComponentIdentifier3.pick)(Popover.Trigger, this.props.children);
      if (trigger) {
        var _this$props2 = this.props,
          on = _this$props2.on,
          shouldContainFocus = _this$props2.shouldContainFocus;
        var onClick;
        var onFocus;
        var onMouseOut;
        var onMouseOver;
        var expanded;
        if (on.indexOf('click') > -1) {
          onClick = function onClick() {
            _this4.toggle();
          };
        }
        if (on.indexOf('hover') > -1) {
          /*#__PURE__*/
          (/*#__PURE__*/
          0, _console.error)(!(on === 'hover'), '[Popover] Specifying only the `"hover"` trigger limits the visibilty of the Popover to just mouse users. ' + 'Consider also including the `"focus"` trigger ' + 'so that touch and keyboard only users can see the Popover content as well.');
          onMouseOver = this._handleMouseOver;
          onMouseOut = this._handleMouseOut;
        }
        if (on.indexOf('focus') > -1) {
          onFocus = function onFocus() {
            _this4.show();
          };
        }
        if (shouldContainFocus) {
          // only set aria-expanded if popover can contain focus
          expanded = this.shown ? 'true' : 'false';
        } else {
          expanded = null;
        }
        trigger = (0, _safeCloneElement.default)(trigger, {
          ref: function ref(el) {
            _this4._trigger = el;
          },
          'aria-expanded': expanded,
          onKeyDown: (0, _createChainedFunction.default)(this.handleTriggerKeyDown, this.props.onKeyDown),
          onClick: (0, _createChainedFunction.default)(onClick, this.props.onClick),
          onBlur: (0, _createChainedFunction.default)(this.handleTriggerBlur, this.props.onBlur),
          onFocus: (0, _createChainedFunction.default)(onFocus, this.props.onFocus),
          onMouseOut: (0, _createChainedFunction.default)(onMouseOut, this.props.onMouseOut),
          onMouseOver: (0, _createChainedFunction.default)(onMouseOver, this.props.onMouseOver)
        });
      }
      return trigger;
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      var _this5 = this;
      return this.props.closeButtonLabel ? _react.default.createElement(_CloseButton.default, {
        placement: this.state.closeButtonPlacement,
        offset: "x-small",
        variant: this.props.variant === 'inverse' ? 'icon-inverse' : 'icon',
        buttonRef: function buttonRef(el) {
          _this5._closeButton = el;
          if (typeof _this5.props.closeButtonRef === 'function') {
            _this5.props.closeButtonRef(el);
          }
        },
        onClick: this.hide
      }, this.props.closeButtonLabel) : null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this6 = this;
      var content = (0, _ComponentIdentifier3.pick)(Popover.Content, this.props.children);
      if (this.shown) {
        content = _react.default.createElement(_Dialog.default, Object.assign({}, (0, _passthroughProps.pickProps)(this.props, _Dialog.default.propTypes), {
          ref: function ref(el) {
            return _this6._dialog = el;
          },
          display: "block",
          open: this.shown,
          onBlur: this.handleDialogBlur,
          onDismiss: this.handleDialogDismiss,
          defaultFocusElement: this.defaultFocusElement,
          shouldFocusOnOpen: !this.props.shouldFocusContentOnTriggerBlur
        }), content);
      }
      if (this.shown || this.props.shouldRenderOffscreen) {
        var ViewElement;
        var viewProps = {
          ref: function ref(c) {
            return _this6._view = c;
          },
          elementRef: this.props.contentRef,
          background: this.props.variant,
          stacking: this.props.stacking,
          shadow: this.props.shadow,
          display: 'block'
        };
        var placement = this.state.placement;
        if (this.props.withArrow) {
          ViewElement = _ContextView.default;
          viewProps = (0, _objectSpread2.default)({}, viewProps, {
            placement: this.rtl ? (0, _mirrorPlacement.mirrorHorizontalPlacement)(placement, ' ') : placement
          });
        } else {
          ViewElement = _View.default;
          viewProps = (0, _objectSpread2.default)({}, viewProps, {
            borderWidth: 'small',
            borderRadius: 'medium'
          });
        }
        return _react.default.createElement(ViewElement, viewProps, this.renderCloseButton(), content);
      } else {
        return null;
      }
    }
  }, {
    key: "computeOffsets",
    value: function computeOffsets(placement) {
      var _this$props3 = this.props,
        offsetX = _this$props3.offsetX,
        offsetY = _this$props3.offsetY;
      if (this.props.alignArrow && this._view) {
        var secondaryPlacement = (0, _calculateElementPosition.parsePlacement)(placement)[1];
        var _this$_view$theme = this._view.theme,
          arrowSize = _this$_view$theme.arrowSize,
          arrowBorderWidth = _this$_view$theme.arrowBorderWidth;
        var offsetAmount = ((0, _px.default)(arrowSize) + (0, _px.default)(arrowBorderWidth)) * 2;
        if (secondaryPlacement === 'start') {
          offsetX = offsetAmount;
        } else if (secondaryPlacement === 'end') {
          offsetX = -offsetAmount;
        } else if (secondaryPlacement === 'top') {
          offsetY = offsetAmount;
        } else if (secondaryPlacement === 'bottom') {
          offsetY = -offsetAmount;
        }
      }
      return {
        offsetX: offsetX,
        offsetY: offsetY
      };
    }
  }, {
    key: "render",
    value: function render() {
      var positionProps = this.positionProps;
      if (this.props.positionTarget) {
        return _react.default.createElement("span", null, this.renderTrigger(), _react.default.createElement(_Position.default, positionProps, _react.default.createElement(_Position.PositionContent, null, this.renderContent())));
      } else {
        return _react.default.createElement(_Position.default, positionProps, _react.default.createElement(_Position.PositionTarget, null, this.renderTrigger()), _react.default.createElement(_Position.PositionContent, null, this.renderContent()));
      }
    }
  }, {
    key: "placement",
    get: function get() {
      var placement = this.props.placement;
      if (this.rtl) {
        placement = (0, _mirrorPlacement.mirrorHorizontalPlacement)(placement, ' ');
      }
      return !this.shown && this.props.shouldRenderOffscreen ? 'offscreen' : placement;
    }
  }, {
    key: "shown",
    get: function get() {
      return typeof this.props.show === 'undefined' ? this.state.show : this.props.show;
    }
  }, {
    key: "defaultFocusElement",
    get: function get() {
      return this.props.defaultFocusElement;
    }
  }, {
    key: "positionProps",
    get: function get() {
      return (0, _objectSpread2.default)({}, (0, _passthroughProps.pickProps)(this.props, _Position.default.propTypes), {
        offsetX: this.state.offsetX,
        offsetY: this.state.offsetY,
        trackPosition: this.shown,
        placement: this.placement,
        onPositioned: (0, _createChainedFunction.default)(this.handlePositionChanged, this.props.onShow),
        onPositionChanged: this.handlePositionChanged,
        target: this.props.positionTarget,
        id: this._id
      });
    }
  }]);
  Popover.displayName = "Popover";
  return Popover;
}(_react.Component), _class6.Trigger = PopoverTrigger, _class6.Content = PopoverContent, _class6.propTypes = {
  /**
   * Children of the `<Popover />`
   */
  children: _uiPropTypes.Children.oneOf([PopoverTrigger, PopoverContent]),
  /**
   * The placement of the content in relation to the trigger
   */
  placement: _LayoutPropTypes.default.placement,
  /**
   * The action that causes the Content to display (`click`, `hover`, `focus`)
   */
  on: _propTypes.default.oneOfType([_propTypes.default.oneOf(['click', 'hover', 'focus']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['click', 'hover', 'focus']))]),
  variant: _propTypes.default.oneOf(['default', 'inverse']),
  /**
  * Controls the shadow depth for the `<Popover />`
  */
  shadow: _ThemeablePropTypes.default.shadow,
  /**
  * Controls the z-index depth for the `<Popover />` content
  */
  stacking: _ThemeablePropTypes.default.stacking,
  /**
   * Whether or not the content should be rendered on initial render.
   */
  defaultShow: _propTypes.default.bool,
  /**
  * Whether or not the `<Popover />` is shown (should be accompanied by `onToggle`)
  */
  show: (0, _uiPropTypes.controllable)(_propTypes.default.bool, 'onToggle', 'defaultShow'),
  /**
   *
   * A function that returns a reference to the content element
   */
  contentRef: _propTypes.default.func,
  /**
   * Call this function when the content visibility is toggled. When used with `show`,
   * `<Popover />` will not control its own state.
   */
  onToggle: _propTypes.default.func,
  /**
   * Callback fired when component is clicked
   */
  onClick: _propTypes.default.func,
  /**
   * Callback fired when trigger is focused
   */
  onFocus: _propTypes.default.func,
  /**
   * Callback fired when component is blurred
   */
  onBlur: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  /**
   * Callback fired when content is rendered and positioned
   */
  onShow: _propTypes.default.func,
  /**
   * Callback fired when mouse is over trigger
   */
  onMouseOver: _propTypes.default.func,
  /**
   * Callback fired when mouse leaves trigger
   */
  onMouseOut: _propTypes.default.func,
  /**
   * Callback fired when the `<Popover />` requests to be hidden (via close button, escape key, etc.)
   */
  onDismiss: _propTypes.default.func,
  /**
  * Should the `<Popover />` display with an arrow pointing to the trigger
  */
  withArrow: _propTypes.default.bool,
  /**
   * An accessible label for the close button. The close button won't display without this label.
   */
  closeButtonLabel: _propTypes.default.string,
  /**
   * A function that returns a reference to the close button element
   */
  closeButtonRef: _propTypes.default.func,
  /**
   * An accessible label for the `<Popover />` content
   */
  label: _propTypes.default.string,
  /**
   * An element or a function returning an element to focus by default
   */
  defaultFocusElement: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  /**
  * Should the `<Popover />` render offscreen when visually hidden
  */
  shouldRenderOffscreen: _propTypes.default.bool,
  /**
   * Whether focus should contained within the `<Popover/>` when it is open
   */
  shouldContainFocus: _propTypes.default.bool,
  /**
   * Whether focus should be returned to the trigger when the `<Popover/>` is closed
   */
  shouldReturnFocus: _propTypes.default.bool,
  /**
   * Should the `<Popover />` hide when clicks occur outside the content
   */
  shouldCloseOnDocumentClick: _propTypes.default.bool,
  /**
   * Should the `<Popover />` hide when the escape key is pressed
   */
  shouldCloseOnEscape: _propTypes.default.bool,
  /**
   * The horizontal offset for the positioned content
   */
  offsetX: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * The vertical offset for the positioned content
   */
  offsetY: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Callback fired when the position changes
   */
  onPositionChanged: _propTypes.default.func,
  /**
   * Callback fired when content has been mounted and is initially positioned
   */
  onPositioned: _propTypes.default.func,
  /**
   * Whether or not position should be tracked or just set on initial render
   */
  trackPosition: _propTypes.default.bool,
  /**
   * The parent in which to constrain the popover.
   * One of: 'window', 'scroll-parent', 'parent', 'none', an element,
   * or a function returning an element
   */
  constrain: _LayoutPropTypes.default.constrain,
  /**
   * An element or a function returning an element to use as the mount node
   * for the `<Popover />` (defaults to `document.body`)
   */
  mountNode: _LayoutPropTypes.default.mountNode,
  /**
   * Insert the element at the 'top' of the mountNode or at the 'bottom'
   */
  insertAt: _propTypes.default.oneOf(['bottom', 'top']),
  /**
   * An element, function returning an element, or array of elements that will not be hidden from
   * the screen reader when the `<Popover />` is open
   */
  liveRegion: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element, _propTypes.default.func]),
  /**
   * Target element for positioning the Popover (if it differs from the trigger)
   */
  positionTarget: _propTypes.default.oneOfType([_uiPropTypes.element, _propTypes.default.func]),
  /**
   * should the content offset to align by its arrow
   */
  alignArrow: _propTypes.default.bool,
  id: _propTypes.default.string,
  /**
   * should the content become focused when the trigger is blurred
   */
  shouldFocusContentOnTriggerBlur: _propTypes.default.bool
}, _class6.defaultProps = {
  children: null,
  onToggle: function onToggle(open) {},
  onClick: function onClick(event) {},
  onFocus: function onFocus(event) {},
  onBlur: function onBlur(event) {},
  onMouseOver: function onMouseOver(event) {},
  onMouseOut: function onMouseOut(event) {},
  onShow: function onShow(position) {},
  onDismiss: function onDismiss(event, documentClick) {},
  placement: 'bottom center',
  stacking: 'topmost',
  shadow: 'resting',
  offsetX: 0,
  offsetY: 0,
  variant: 'default',
  on: ['hover', 'focus'],
  contentRef: function contentRef(el) {},
  defaultShow: false,
  withArrow: true,
  trackPosition: true,
  constrain: 'window',
  onPositioned: function onPositioned(position) {},
  onPositionChanged: function onPositionChanged(position) {},
  shouldRenderOffscreen: false,
  shouldContainFocus: false,
  shouldReturnFocus: true,
  shouldCloseOnDocumentClick: true,
  shouldFocusContentOnTriggerBlur: false,
  shouldCloseOnEscape: true,
  defaultFocusElement: null,
  label: null,
  mountNode: null,
  insertAt: 'bottom',
  liveRegion: null,
  positionTarget: null,
  alignArrow: false,
  id: void 0,
  show: void 0,
  closeButtonRef: void 0,
  closeButtonLabel: void 0,
  onKeyDown: void 0
}, _temp3)) || _class5) || _class5) || _class5) || _class5);
var _default = Popover;
exports.default = _default;